module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row-logo"
  }, [_c('div', {
    staticClass: "main-width set-position"
  }, [_c('img', {
    attrs: {
      "src": "/yuncai/img/logo.png",
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "inline-block",
      "position": "relative",
      "top": "34px",
      "left": "10px"
    }
  }, [_vm._v("帮助企业做"), _c('br'), _vm._v("最佳采购决策和高效协同")]), _vm._v(" "), _c('div', {
    staticClass: "input-group pull-right hidden"
  }, [_c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "搜索商机/物资"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-group-btn"
  }, [_c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button"
    }
  }, [_c('img', {
    attrs: {
      "src": "static/imgs/search.png"
    }
  })])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-70b7874f!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/G-logo.vue
// module id = 24
// module chunks = 4 5 6 7 8 9 10 11 12 13 14 15